import { GenericTestRouteState } from './generic-test-state'

export const FunctionalTestRouteState = GenericTestRouteState.named(
  'FunctionalTestRouteState'
)
